import { queryOptions } from "@tanstack/react-query";
import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";
import buildUrlWithParams from "./buildUrlWithParams";

const userSettingsQueryOptions = (params: { userId: string }) => {
  return queryOptions({
    queryKey: ["userSettings", params],
    queryFn: async ({ signal }) => {
      const url = buildUrlWithParams(
        `/api/users/v1/user_settings/${params.userId}`,
        params,
      );

      const res = await fetchOrchidAPI(url, { signal });
      if (!res.ok) {
        if (res.status === 404) {
          return {} as UserSettings; // Return empty object if user settings not found
        }
        throw new Error(
          `failed to query user settings: ${getErrorDetail(await res.text())}`,
        );
      }
      const json = await res.json();
      return json.settings as UserSettings;
    },
  });
};

export default userSettingsQueryOptions;
